import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import storeIcon from '../../assets/SVGs/Vector.svg';
import storeIconDisabled from '../../assets/SVGs/VectorDisabled.svg';
import {
	NEED_TO_BE_SELECTED,
	states,
	NETSALES,
	UNITS,
	GMV,
	StoreChannel,
	OmniChannel,
	eComChannel,
	locationArr,
	displayMetric,
	BOGLE_LIGHT,
	channelOptionMapping,
	metricDomain,
} from '../../constants/constant';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useStyles, styles, selectStyleMenu } from './styles';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import AddItem from './AddItems/AddItem';
import { getKeyByValue } from '../../helper/commonUtils';

const getLocation = (arr, key) => {
	return arr.find((obj) => {
		return obj.name === key;
	});
};

const ComparisonLocation = ({
	metricA,
	metricB,
	getLocationData,
	editRuleData,
}) => {
	const cbKeyA = getKeyByValue(
		channelOptionMapping,
		editRuleData?.left?.channelType
	);
	const cbKeyB = getKeyByValue(
		channelOptionMapping,
		editRuleData?.right?.channelType
	);
	const editLocationA = getLocation(locationArr, editRuleData?.left?.location);
	const editLocationB = getLocation(locationArr, editRuleData?.right?.location);

	const [cbA, setCBA] = useState(editRuleData ? cbKeyA : NEED_TO_BE_SELECTED);
	const [cbB, setCBB] = useState(editRuleData ? cbKeyB : NEED_TO_BE_SELECTED);

	const [locationA, setLocationA] = useState(
		editRuleData ? editLocationA?.name : null
	);

	const [locationB, setLocationB] = useState(
		editRuleData ? editLocationB?.name : null
	);
	const [channelAOptions, setChannelAOptions] = useState(
		editRuleData ? editRuleData?.left?.channels : []
	);
	const [channelBOptions, setChannelBOptions] = useState(
		editRuleData ? editRuleData?.right?.channels : []
	);

	const [stateAOptions, setStateAOptions] = useState(
		editRuleData ? editRuleData?.left?.locationFilters : []
	);
	const [stateBOptions, setStateBOptions] = useState(
		editRuleData ? editRuleData?.right?.locationFilters : []
	);

	const [addStoreA, setAddStoreA] = useState(false);
	const [addStoreB, setAddStoreB] = useState(false);
	const [storeListA, setStoreListA] = useState({});
	const [storeListB, setStoreListB] = useState({});

	const isSmallScreen = useMediaQuery('(max-width:425px)');

	const classes = useStyles();

	useEffect(() => {
		setChannelAOptions([]);
		setStateAOptions([]);
	}, [locationA]);

	useEffect(() => {
		setChannelBOptions([]);
		setStateBOptions([]);
	}, [locationB]);

	useEffect(() => {
		if (cbKeyA !== cbA) {
			setLocationA(null);
			setChannelAOptions([]);
			setStateAOptions([]);
		} else {
			setLocationA(editRuleData ? editLocationA?.name : null);
			setChannelAOptions(editRuleData ? editRuleData?.left?.channels : []);
			setStateAOptions(editRuleData ? editRuleData?.left?.locationFilters : []);
		}
	}, [metricA]);

	useEffect(() => {
		if (cbKeyB !== cbB) {
			setLocationB(null);
			setChannelBOptions([]);
			setStateBOptions([]);
		} else {
			setLocationB(editRuleData ? editLocationB?.name : null);
			setChannelBOptions(editRuleData ? editRuleData?.right?.channels : []);
			setStateBOptions(
				editRuleData ? editRuleData?.right?.locationFilters : []
			);
		}
	}, [metricB]);

	useEffect(() => {
		if (cbKeyA !== cbA) {
			setLocationA(null);
			setChannelAOptions([]);
			setStateAOptions([]);
		} else {
			setLocationA(editRuleData ? editLocationA?.name : null);
			setChannelAOptions(editRuleData ? editRuleData?.left?.channels : []);
			setStateAOptions(editRuleData ? editRuleData?.left?.locationFilters : []);
		}
	}, [cbA, metricA]);

	useEffect(() => {
		if (cbKeyB !== cbB) {
			setLocationB(null);

			setChannelBOptions([]);

			setStateBOptions([]);
		} else {
			setLocationB(editRuleData ? editLocationB?.name : null);
			setChannelBOptions(editRuleData ? editRuleData?.right?.channels : []);
			setStateBOptions(
				editRuleData ? editRuleData?.right?.locationFilters : []
			);
		}
	}, [cbB, metricB]);

	useEffect(() => {
		const data = {
			A: {
				locationA: locationA,
				channelsA: channelAOptions,
				locationFiltersA:
					locationA === 'STORES' ? storeListA?.selectedItems : stateAOptions,
				channelTypeA: channelOptionMapping[cbA],
			},
			B: {
				locationB: locationB,
				channelsB: channelBOptions,
				locationFiltersB:
					locationB === 'STORES' ? storeListB?.selectedItems : stateBOptions,
				channelTypeB: channelOptionMapping[cbB],
			},
		};
		getLocationData(data);
	}, [
		locationA,
		locationB,
		channelAOptions,
		channelBOptions,
		stateAOptions,
		stateBOptions,
		cbA,
		cbB,
		storeListA,
		storeListB,
	]);

	const handleCBChangeA = (event) => {
		setCBA(event.target.value);
	};
	const handleCBChangeB = (event) => {
		setCBB(event.target.value);
	};

	const handleLocationAChange = (event) => {
		setLocationA(event.target.value);
	};
	const handleLocationBChange = (event) => {
		setLocationB(event.target.value);
	};
	const handleStoreAIconClick = () => {
		setAddStoreA(true);
	};

	const handleStoreBIconClick = () => {
		setAddStoreB(true);
	};

	const handleAChange = (event) => {
		const {
			target: { value },
		} = event;
		setChannelAOptions(
			// On autofill we get a stringified value.
			typeof value === 'string' ? value.split(',') : value
		);
	};
	const handleBChange = (event) => {
		const {
			target: { value },
		} = event;
		setChannelBOptions(
			// On autofill we get a stringified value.
			typeof value === 'string' ? value.split(',') : value
		);
	};
	const getChannel = (item) => {
		if (item === 'Omni') {
			return OmniChannel;
		} else if (item === 'eComm') {
			return eComChannel;
		} else {
			return StoreChannel;
		}
	};

	const handleStateAChange = (event) => {
		const {
			target: { value },
		} = event;
		setStateAOptions(typeof value === 'string' ? value?.split(',') : value);
	};
	const handleStateBChange = (event) => {
		const {
			target: { value },
		} = event;
		setStateBOptions(typeof value === 'string' ? value?.split(',') : value);
	};

	const getChannelOptions = (metric) => {
		if ([NETSALES, UNITS].includes(metric)) {
			return ['Omni', 'Store', 'eComm'];
		} else if ([GMV].includes(metric)) {
			return ['Omni', 'eComm'];
		}
		return ['Store'];
	};

	const getLocationOptions = (channel) => {
		if (['Omni', 'eComm'].includes(channel)) {
			return [{ name: 'USA', value: 'Entire United States' }];
		} else {
			return locationArr;
		}
	};

	const getStoreSelectionA = (list) => {
		setStoreListA(list);
	};

	const getStoreSelectionB = (list) => {
		setStoreListB(list);
	};

	const cbArrA = getChannelOptions(displayMetric[metricA]);
	const cbArrB = getChannelOptions(displayMetric[metricB]);

	const locationOptionsA = getLocationOptions(cbA);
	const locationOptionsB = getLocationOptions(cbB);

	const dispalayLocationText = (
		cb,
		channelOptions,
		metricDomain,
		location,
		stateOptions,
		storeList
	) => {
		if (cb !== 'Store' && channelOptions?.length > 0) {
			return `${cb}, ${channelOptions}`;
		} else if (
			metricDomain !== 'SALES' &&
			location === 'STATES' &&
			stateOptions?.length > 0
		) {
			return `${cb}, ${location}, multiple states selected`;
		} else if (
			metricDomain !== 'SALES' &&
			location === 'STORES' &&
			storeList?.selectedItems?.length
		) {
			return `${cb}, ${location},  multiple stores selected`;
		} else if (metricDomain !== 'SALES' && location === 'USA') {
			return `${cb}, ${location}`;
		} else if (
			location === 'STORES' &&
			channelOptions?.length > 0 &&
			storeList?.selectedItems?.length
		) {
			return `${cb}, ${location},  multiple stores selected, ${channelOptions}`;
		} else if (
			location === 'STATES' &&
			channelOptions?.length > 0 &&
			stateOptions?.length > 0
		) {
			return `${cb}, ${location}, multiple states selected, ${channelOptions}`;
		} else if (location === 'USA' && channelOptions?.length > 0) {
			return `${cb}, ${location},${channelOptions}`;
		}
		return NEED_TO_BE_SELECTED;
	};

	return (
		<>
			<Accordion
				elevation={0}
				classes={{
					root: classes.MuiAccordionroot,
				}}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="channelBreakdown-content"
					id="cb-header"
					sx={{ borderTop: '1px solid lightgray', margin: 0 }}>
					<Grid container>
						{[cbA, cbB]?.map((item, key) => {
							return (
								<Grid item xs={12} sm={6} md={6} lg={6} key={key}>
									<Box
										className={classes.boxStyle}
										style={
											key === 1 && !isSmallScreen ? { marginLeft: '15px' } : {}
										}>
										{isSmallScreen ? (
											key === 0 && (
												<>
													<Typography className={classes.menuItems}>
														Channel Breakdown
													</Typography>
													<Typography
														className={classes.menuItems}
														style={{ fontSize: 12, paddingTop: '6px' }}>
														{key === 0 &&
															dispalayLocationText(
																cbA,
																channelAOptions,
																metricDomain[metricA],
																locationA,
																stateAOptions,
																storeListA
															)}
														{key !== 0 &&
															dispalayLocationText(
																cbB,
																channelBOptions,
																metricDomain[metricB],
																locationB,
																stateBOptions,
																storeListB
															)}
													</Typography>
												</>
											)
										) : (
											<>
												<Typography className={classes.menuItems}>
													Channel Breakdown
												</Typography>
												<Typography
													className={classes.menuItems}
													style={{ fontSize: 12, paddingTop: '6px' }}>
													{key === 0 &&
														dispalayLocationText(
															cbA,
															channelAOptions,
															metricDomain[metricA],
															locationA,
															stateAOptions,
															storeListA
														)}
													{key !== 0 &&
														dispalayLocationText(
															cbB,
															channelBOptions,
															metricDomain[metricB],
															locationB,
															stateBOptions,
															storeListB
														)}
												</Typography>
											</>
										)}
									</Box>
								</Grid>
							);
						})}
					</Grid>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container>
						{isSmallScreen && (
							<Grid item xs={12}>
								<Typography className={classes.menuItemsType}>A</Typography>
							</Grid>
						)}
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}>
								<InputLabel id="cb-label" sx={{ ...styles.textField }}>
									Channel Breakdown
								</InputLabel>
								<Select
									id="Channel Breakdown"
									value={cbA}
									label="Channel Breakdown"
									onChange={handleCBChangeA}
									sx={{
										fontFamily: BOGLE_LIGHT,
										fontSize: 14,
									}}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{cbArrA?.map((name) => (
										<MenuItem
											key={name}
											value={name}
											className={classes.menuItems}>
											{name}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<FormControl
								sx={{
									...styles.comMetricSelect,
									...styles.outline,
									marginTop: '25px',
								}}>
								<InputLabel
									id="simple-select-helper-label"
									sx={{ ...styles.textField }}>
									Location
								</InputLabel>
								<Select
									id="Location"
									value={locationA}
									label="Location"
									name="location"
									sx={{
										fontFamily: BOGLE_LIGHT,
										fontSize: 14,
									}}
									onChange={handleLocationAChange}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{locationOptionsA?.map((data, key) => (
										<MenuItem
											key={key}
											value={data?.name}
											className={classes.menuItems}>
											{data?.value}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<Box
								className={
									locationA === 'STORES'
										? classes.addStore
										: classes.disableAddStore
								}
								onClick={
									locationA === 'STORES' ? handleStoreAIconClick : () => {}
								}>
								<img
									alt="storeIcon"
									src={locationA === 'STORES' ? storeIcon : storeIconDisabled}
								/>
								<span style={{ marginLeft: '10px' }}>
									{locationA !== 'STORES' ? 'Store Only' : 'Add Stores'}
								</span>
							</Box>

							{locationA === 'STATES' && (
								<FormControl
									sx={{ ...styles.comMetricSelect, ...styles.outline }}
									style={{ marginTop: '25px' }}>
									<InputLabel
										id="simple-select-helper-label"
										sx={{ ...styles.textField }}>
										State
									</InputLabel>
									<Select
										labelId="demo-multiple-checkbox-label"
										id="demo-multiple-checkbox"
										multiple
										value={stateAOptions}
										onChange={handleStateAChange}
										input={<OutlinedInput label="State" />}
										renderValue={(selected) => selected.join(', ')}
										sx={{
											fontFamily: BOGLE_LIGHT,
											fontSize: 14,
										}}
										MenuProps={{
											sx: selectStyleMenu,
											disablePortal: true,
										}}>
										{states?.map((data) => (
											<MenuItem key={data?.name} value={data?.name}>
												<Checkbox
													checked={stateAOptions.indexOf(data?.name) > -1}
												/>
												<ListItemText primary={data.value} />
											</MenuItem>
										))}
									</Select>
								</FormControl>
							)}

							{cbA !== NEED_TO_BE_SELECTED &&
								[NETSALES, UNITS, GMV].includes(displayMetric[metricA]) && (
									<FormControl
										sx={{ ...styles.comMetricSelect, ...styles.outline }}
										style={{ marginTop: '25px' }}>
										<InputLabel
											id="simple-select-helper-label"
											sx={{
												...styles.textField,
											}}>
											Channel option
										</InputLabel>

										<Select
											labelId="demo-multiple-checkbox-label"
											id="demo-multiple-checkbox"
											multiple
											value={channelAOptions}
											onChange={handleAChange}
											input={<OutlinedInput label="Channel option" />}
											renderValue={(selected) => selected.join(', ')}
											sx={{
												fontFamily: BOGLE_LIGHT,
												fontSize: 14,
											}}
											MenuProps={{
												sx: selectStyleMenu,
												disablePortal: true,
											}}>
											{getChannel(cbA)?.map((data) => (
												<MenuItem key={data?.name} value={data?.name}>
													<Checkbox
														checked={channelAOptions.indexOf(data.name) > -1}
													/>
													<ListItemText primary={data.value} />
												</MenuItem>
											))}
										</Select>
									</FormControl>
								)}
						</Grid>
						<Grid item xs={12} sm={6} md={6} lg={6}>
							{isSmallScreen && (
								<Grid item xs={12}>
									<Typography className={classes.menuItemsType}>B</Typography>
								</Grid>
							)}
							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}>
								<InputLabel id="cb-label" sx={{ ...styles.textField }}>
									Channel Breakdown
								</InputLabel>
								<Select
									id="Channel Breakdown"
									value={cbB}
									label="Channel Breakdown"
									onChange={handleCBChangeB}
									sx={{
										fontFamily: BOGLE_LIGHT,
										fontSize: 14,
									}}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{cbArrB?.map((name) => (
										<MenuItem
											key={name}
											value={name}
											className={classes.menuItems}>
											{name}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<FormControl
								sx={{
									...styles.comMetricSelect,
									...styles.outline,
									marginTop: '25px',
								}}>
								<InputLabel
									id="simple-select-helper-label"
									sx={{ ...styles.textField }}>
									Location
								</InputLabel>
								<Select
									id="Location"
									value={locationB}
									label="Location"
									name="location"
									sx={{
										fontFamily: BOGLE_LIGHT,
										fontSize: 14,
									}}
									onChange={handleLocationBChange}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{locationOptionsB?.map((data, key) => (
										<MenuItem
											key={key}
											value={data?.name}
											className={classes.menuItems}>
											{data?.value}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<Box
								className={
									locationB === 'STORES'
										? classes.addStore
										: classes.disableAddStore
								}
								onClick={
									locationB === 'STORES' ? handleStoreBIconClick : () => {}
								}>
								<img
									alt="storeIcon"
									src={locationB === 'STORES' ? storeIcon : storeIconDisabled}
								/>
								<span style={{ marginLeft: '10px' }}>
									{locationB !== 'STORES' ? 'Store Only' : 'Add Stores'}
								</span>
							</Box>

							{locationB === 'STATES' && (
								<FormControl
									sx={{ ...styles.comMetricSelect, ...styles.outline }}
									style={{ marginTop: '25px' }}>
									<InputLabel
										id="simple-select-helper-label"
										sx={{ ...styles.textField }}>
										State
									</InputLabel>
									<Select
										labelId="demo-multiple-checkbox-label"
										id="demo-multiple-checkbox"
										multiple
										value={stateBOptions}
										onChange={handleStateBChange}
										input={<OutlinedInput label="State" />}
										renderValue={(selected) => selected.join(', ')}
										sx={{
											fontFamily: BOGLE_LIGHT,
											fontSize: 14,
										}}
										MenuProps={{
											sx: selectStyleMenu,
											disablePortal: true,
										}}>
										{states?.map((data) => (
											<MenuItem key={data?.name} value={data?.name}>
												<Checkbox
													checked={stateBOptions.indexOf(data?.name) > -1}
												/>
												<ListItemText primary={data?.value} />
											</MenuItem>
										))}
									</Select>
								</FormControl>
							)}

							{cbB !== NEED_TO_BE_SELECTED &&
								[NETSALES, UNITS, GMV].includes(displayMetric[metricB]) && (
									<FormControl
										sx={{ ...styles.comMetricSelect, ...styles.outline }}
										style={{ marginTop: '25px' }}>
										<InputLabel
											id="simple-select-helper-label"
											sx={{
												...styles.textField,
											}}>
											Channel option
										</InputLabel>

										<Select
											labelId="demo-multiple-checkbox-label"
											id="demo-multiple-checkbox"
											multiple
											value={channelBOptions}
											onChange={handleBChange}
											input={<OutlinedInput label="Channel option" />}
											renderValue={(selected) => selected.join(', ')}
											sx={{
												fontFamily: BOGLE_LIGHT,
												fontSize: 14,
											}}
											MenuProps={{
												sx: selectStyleMenu,
												disablePortal: true,
											}}>
											{getChannel(cbB)?.map((data) => (
												<MenuItem key={data?.name} value={data?.name}>
													<Checkbox
														checked={channelBOptions.indexOf(data?.name) > -1}
													/>
													<ListItemText primary={data?.value} />
												</MenuItem>
											))}
										</Select>
									</FormControl>
								)}
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>

			<AddItem
				isOpen={addStoreA ? true : false}
				type={'Store'}
				setIsAddItemsOpen={setAddStoreA}
				getData={getStoreSelectionA}
				isComparison={'A'}
			/>
			<AddItem
				isOpen={addStoreB ? true : false}
				type={'Store'}
				setIsAddItemsOpen={setAddStoreB}
				getData={getStoreSelectionB}
				isComparison={'B'}
			/>
		</>
	);
};

ComparisonLocation.propTypes = {
	metricA: PropTypes.string,
	metricB: PropTypes.string,
	getLocationData: PropTypes.func,
	editRuleData: PropTypes.object,
};

export default ComparisonLocation;
